import Socials from './Socials'
import './Socials.scss'

export default Socials
